export default "__VITE_ASSET__I310xsez__"